var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkAreaHorizontalSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_134_8978",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.538086,
    y: 0.176758,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_134_8978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.53809 11.1768C4.98809 11.1768 4.51709 10.9808 4.12509 10.5888C3.73375 10.1974 3.53809 9.72676 3.53809 9.17676V5.17676C3.53809 4.62676 3.73375 4.15576 4.12509 3.76376C4.51709 3.37242 4.98809 3.17676 5.53809 3.17676H19.5381C20.0881 3.17676 20.5591 3.37242 20.9511 3.76376C21.3424 4.15576 21.5381 4.62676 21.5381 5.17676V9.17676C21.5381 9.72676 21.3424 10.1974 20.9511 10.5888C20.5591 10.9808 20.0881 11.1768 19.5381 11.1768H5.53809ZM5.53809 21.1768C4.98809 21.1768 4.51709 20.9811 4.12509 20.5898C3.73375 20.1978 3.53809 19.7268 3.53809 19.1768V15.1768C3.53809 14.6268 3.73375 14.1558 4.12509 13.7638C4.51709 13.3724 4.98809 13.1768 5.53809 13.1768H19.5381C20.0881 13.1768 20.5591 13.3724 20.9511 13.7638C21.3424 14.1558 21.5381 14.6268 21.5381 15.1768V19.1768C21.5381 19.7268 21.3424 20.1978 20.9511 20.5898C20.5591 20.9811 20.0881 21.1768 19.5381 21.1768H5.53809Z",
    fill: "#4267F4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkAreaHorizontalSelected);
export default __webpack_public_path__ + "static/media/bookmark_area_horizontal_selected.49e03fa2f463fa57e8f3fab27c53de07.svg";
export { ForwardRef as ReactComponent };